import './index.less';


import BaseRecorder from './recorders/baseRecorder';
import CCaptureRecorder from './recorders/ccaptureRecorder';
import saveThumbnail from './recorders/thumbnailCapture';
import { BaseRenderer } from './renderers/baseRenderer';

import P5Renderer from './renderers/p5Renderer';


let formatSelect: HTMLSelectElement = document.getElementById('formatSelect') as HTMLSelectElement;
let recordBtn = document.getElementById('recordBtn');

class App {
    debugging: boolean = false;
    renderer: BaseRenderer;
    recorder: BaseRecorder;

    constructor() {        
        //const creator = new URLSearchParams(window.location.search).get('creator')
        //const viewer = new URLSearchParams(window.location.search).get('viewer')

        //if (creator !== null) {
        //    this.debugging = true;
        //}

        this.renderer = new P5Renderer(window.innerWidth, window.innerHeight);
        
        if (!this.debugging) {
            recordBtn.style.display = 'none';
            formatSelect.style.display = 'none';
        } else {
            this.recorder = new CCaptureRecorder();
            recordBtn.addEventListener('click', () => this.handleRecordBtnClick())
            formatSelect.addEventListener('change', () => this.handleFormatSelectChange())
        }

        this.animation();
    }

    handleRecordBtnClick() {
        if (formatSelect.value == 'thumbnail') {
            saveThumbnail(this.renderer.canvas);
        } else {
            if (this.recorder) {
                this.recorder.setCanvas(this.renderer.canvas);
                this.recorder.start();
            }

            this.renderer.play();
            this.renderer.setCompleteCallback(() => this.handleComplete());
        }
    }

    handleFormatSelectChange() {
        if (formatSelect.value !== 'thumbnail') {
            this.recorder.setFormat(formatSelect.value);
        }
    }

    handleComplete() {
        if (this.recorder) {
            this.recorder.stop();
        }
        this.renderer.stop();
    }

    animation() {
        this.renderer.render();
        if (this.recorder) {
            this.recorder.update();
        }
        requestAnimationFrame(() => this.animation());
    }
    
}

new App();